import React from 'react';
import _ from 'lodash';
import { Box, FormControl, FormHelperText, InputLabel, Select, MenuItem, Typography, OutlinedInput } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

import { RequiredField } from '../others/RequiredField';
import { useDynamicAction, useDynamicQuery, useDynamicFunction, useFullScreen } from '../../services/hooks';
import { constructDependsOnParams, getDependsOnValue, handleShowOn, handleDynamicFunction } from '../../services/functions';
import { InfoField } from './InfoField';
import { red } from '@mui/material/colors';

const styles = {
  select: {
    '.MuiOutlinedInput-notchedOutline': {
      borderColor: red[400]
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: red[600]
    }
  }
};

export const ChoiceField = props => {
  const { field, formik, updateOptionsCallback, getFieldCallback, setLoadingCallback, hideFieldCallback, handleDiscountActions, handleParishChange, handleGroupChange, handleEventChange, handlePeriodChange, handleSourceOfOfferChange } = props;
  const mediaWidth = useFullScreen() ? '300px' : '100%';
  const [open, setOpen] = React.useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const action = useDynamicAction(
    field.depends_on,
    field.on_change,
    constructDependsOnParams(field.depends_on, field.name, formik.values
    ),
    formik.values[field.name]
  );
  const { query, data, loading } = useDynamicQuery(action);
  const dynamicFunction = useDynamicFunction(field.on_change_splitted ? field.on_change_splitted[0] : field.on_change);
  const [description, setDescription] = React.useState('');

  React.useEffect(() => {
    updateOptionsCallback(data);
  }, [data]);

  React.useEffect(() => {
    setLoadingCallback(loading);
  }, [loading]);

  const handleChange = (e, v) => {
    formik.setFieldValue(field.name, e.target.value);
    let sections = null;
    if (!_.isNil(dynamicFunction)) {
      const res = handleDynamicFunction(dynamicFunction, formik, field, e.target.value);
      if (res.callback) {
        sections = props[res.callback](res.data, field.options.indexOf(e.target.value), e.target.value);
      }
    }
    if (field.name == 'discount') {
      handleDiscountActions(e.target.value, sections);
    } else if (field.name == 'parish') {
      handleParishChange(e.target.value);
    } else if (field.name == 'event') {
      handleEventChange(e.target.value);
    } else if (field.name == 'source_of_offer') {
      handleSourceOfOfferChange(field.options.filter(o => o.id == e.target.value)[0]);
    } else if (field.name === 'group') {
      handleGroupChange(e.target.value, sections);
    }
    if (field.name == 'period') {
      return handlePeriodChange(v, sections);
    }
    if (!e.target.value) {
      return;
    }
    if (!_.isNil(v.props)) {
      if (v.props['data-description']) {
        setDescription(v.props['data-description']);
      }
    }
    if (!_.isNil(action)) {
      query();
    }
  };

  return (
    <Box style={{ display: field.hide ? 'none' : handleShowOn(
      field.show_on, formik.values,
      getFieldCallback(!_.isNil(field.show_on) ? field.show_on.trim().split(' ')[0].split('-')[0] : []))
      ? ''
      : 'none' }}>
      <Typography variant="subtitle1" >
        <b>{field.label}</b>
        <RequiredField required={field.required} isEmpty={_.isNumber(formik.values[field.name]) ? false : _.isEmpty(formik.values[field.name])} formikError={formik.touched[field.name] && Boolean(formik.errors[field.name])} />
      </Typography>
      <FormControl
        style={{ marginBottom: 15, maxWidth: mediaWidth }}
        fullWidth
        variant="outlined"
        error={formik.touched[field.name] && Boolean(formik.errors[field.name])}>
        {field.depends_on && _.isEmpty(formik.values[getDependsOnValue(field.depends_on)]) && _.isEmpty(field.dynamicOptions)
          ? <Typography color="error">{field.additional_info}</Typography>
          : (
            <>
              <InputLabel htmlFor="tt123">{_.isEmpty(formik.values[field.name]) ? field.label : null}</InputLabel>
              <Select
                input={<OutlinedInput id="tt123" label={_.isEmpty(formik.values[field.name]) ? field.label : null}/>}
                sx={styles.select}
                labelId={field.name}
                value={formik.values[field.name] || ''}
                onChange={(e, v) => handleChange(e, v)}
                open = {open}
                onOpen = {handleOpen}
                onClose = {handleClose}
                name={field.label}
                id="qwe"
                disabled={field.disabled}
                IconComponent={_props => {
                  const rotate = _props.className.toString().includes('iconOpen');

                  return (
                    <div>
                      { rotate
                        ? <div style={{ color: 'red', cursor: 'pointer', marginRight: 5, marginBottom: 5, fontSize: 20 }}>X</div>
                        : <div><KeyboardArrowDownIcon
                          style={{ cursor: 'pointer' }}
                          onClick = {handleOpen}
                        /></div> }
                    </div>
                  );
                }}

              >
                <MenuItem value="">&nbsp;</MenuItem>
                { !_.isNil(formik.values[field.name])
                  ? !_.isNil(field.dynamicOptions)
                    ? _.map(field.dynamicOptions, (item, key) => (
                      <MenuItem style={{ whiteSpace: 'normal' }} key={key} value={item.id} id={item.name} data-description={item.description}>
                        {item.name}
                      </MenuItem>
                    ))
                    : !_.isNil(field.dict_identifier)
                      ? _.map(field.options, (item, key) => (
                        <MenuItem key={key} value={item.id} id={item.name}>
                          {item.name}
                        </MenuItem>
                      ))
                      : _.map(field.options, (name, key) => (
                        <MenuItem key={key} value={name} id={name}>
                          {name}
                        </MenuItem>
                      ))
                  : null}
              </Select>
              <Typography color="green">{description}</Typography>
              {
                !_.isEmpty(field.infos)
                  ? _.map(field.infos, (info, key) => {
                    if (info.no_choices) {
                      return <Typography key={key} color={info.color}>
                        {!_.isNil(formik.values[field.name])
                          ? !_.isNil(field.dynamicOptions)
                            ? field.dynamicOptions.length > 0
                              ? null
                              : info.label
                            : info.label
                          : info.label}
                      </Typography>;
                    }
                  })
                  : null
              }

            </>
          )
        }
        <FormHelperText>{formik.touched[field.name] && formik.errors[field.name]}</FormHelperText>
        {
          !_.isEmpty(field.infos)
            ? _.map(field.infos, (info, key) => {
              if (info.no_choices === false) {
                return <InfoField info={info} key={key} getFieldCallback={getFieldCallback} formikValues={formik.values} />;
              }
            })
            : null
        }
      </FormControl>
    </Box>

  );
};
